import React, { Component } from 'react';
import PT from 'prop-types';
import { MDCTextField } from '../toolkit/material-design-hacks/mdc-textfield';
import cIf from 'classnames';

export class Textbox extends Component {
    constructor(props) {
        super(props);
        this.mdTextboxRef = React.createRef();

        this.inputRef = React.createRef();
    }

    componentDidMount() {
        // Note: we need to instanciate MDCTextField here, since it's required by Material Design
        //eslint-disable-next-line sonarjs/constructor-for-side-effects
        new MDCTextField(this.mdTextboxRef.current);

        if(this.inputRef.current && this.props.focus)
            this.inputRef.current.focus();
    }

    onChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        return (
            <div>
                <div className={
                cIf(
                    ["rese-text-field", "mdc-text-field",
                        {
                            "larger-rese-text-field": this.props.isLarger,
                            "invalid": this.props.isInvalid
                        }
                    ]
                )}
                    ref={this.mdTextboxRef}>
                    <input 
                        ref={this.inputRef}
                        id={this.props.id}
                        name={this.props.name}
                        type={this.props.type}
                        className="rese-text-field-input mdc-text-field__input"
                        onChange={this.onChange.bind(this)}
                        value={this.props.value}
                    />
                    <label className={cIf(["rese-floating-label mdc-floating-label", { "mdc-floating-label--float-above": this.props.value !== "" }])}>
                        {this.props.placeholder}
                    </label>
                    <div className="mdc-line-ripple"></div>
                </div>
                <div className="rese-text-field-error">
                    {this.props.errorMessage}
                </div>
            </div>
        );
    }
}
Textbox.propTypes = {
    id: PT.string,
    name: PT.string,
    type: PT.string,
    value: PT.string,
    placeholder: PT.string,
    isLarger: PT.bool,
    errorMessage: PT.object,
    onChange: PT.func,
    isInvalid: PT.bool,
    focus: PT.bool
};

Textbox.defaultProps = {
    value: "",
    isLarger: false,
    type: "text",
    isInvalid: false,
    focus: false
};

export class SimpleTextBox extends Component {

    render() {
        
        return (
            <input {...this.props} />
        );
    }
}

SimpleTextBox.propTypes = {
};

